import type { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

export function isNonNull<T>(value: T): value is NonNullable<T> {
    return !!value;
}

export function nonNull<T>(): (source: Observable<T>) => Observable<T> {
    return (source: Observable<T>): Observable<T> => source.pipe(
        filter(isNonNull)
    );
}
